import { ReactNode } from "react";

interface MenuSectionProps {
  id?: string;
  title: string;
  subtitle?: string;
  note?: string;
  children: ReactNode;
  isCompact?: boolean;
}

const MenuSection = ({ id, title, subtitle, note, children, isCompact = true }: MenuSectionProps) => {
  return (
    <section id={id} className={isCompact ? "mb-8 md:mb-10 animate-fade-in scroll-mt-20" : "mb-16 md:mb-20 animate-fade-in scroll-mt-20"}>
      <div className={isCompact ? "text-center mb-4 md:mb-5" : "text-center mb-8 md:mb-10"}>
        {/* Top decorative element */}
        <div className={isCompact ? "flex items-center justify-center gap-2 mb-1.5" : "flex items-center justify-center gap-2 mb-3"}>
          <div className={isCompact ? "w-8 h-px bg-gradient-to-r from-transparent via-gold to-gold" : "w-12 h-px bg-gradient-to-r from-transparent via-gold to-gold"}></div>
          <div className={isCompact ? "w-1 h-1 rotate-45 bg-gold" : "w-1.5 h-1.5 rotate-45 bg-gold"}></div>
          <div className={isCompact ? "w-8 h-px bg-gradient-to-l from-transparent via-gold to-gold" : "w-12 h-px bg-gradient-to-l from-transparent via-gold to-gold"}></div>
        </div>
        
        <h2 className={isCompact ? "text-xl md:text-2xl font-serif font-bold text-gold mb-1 tracking-tight drop-shadow-lg" : "text-3xl md:text-4xl font-serif font-bold text-gold mb-3 tracking-tight drop-shadow-lg"}>
          {title}
        </h2>
        {subtitle && (
          <p className={isCompact ? "text-muted-foreground text-[11px] md:text-xs max-w-3xl mx-auto leading-relaxed" : "text-muted-foreground text-sm md:text-base max-w-3xl mx-auto leading-relaxed"}>
            {subtitle}
          </p>
        )}
        
        {note && (
          <p className={isCompact ? "text-gold/60 text-[10px] md:text-xs italic max-w-2xl mx-auto mt-1.5 leading-relaxed" : "text-gold/60 text-xs md:text-sm italic max-w-2xl mx-auto mt-2 leading-relaxed"}>
            ✦ {note} ✦
          </p>
        )}
        
        {/* Bottom decorative element */}
        <div className={isCompact ? "w-10 h-px bg-gradient-to-r from-transparent via-gold to-transparent mx-auto mt-1.5" : "w-16 h-px bg-gradient-to-r from-transparent via-gold to-transparent mx-auto mt-4"}></div>
      </div>
      <div className={isCompact ? "grid gap-1.5 md:gap-2" : "grid gap-4 md:gap-6"}>
        {children}
      </div>
    </section>
  );
};

export default MenuSection;
